var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import dayjs from "dayjs";
import { FormItemTypes } from "../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { renderIcon } from "../../../../../fieldFailureReports/components/CommonFunctions";
import { Box, Link, Typography } from "@mui/material";
import { downloadAttachmentFfrAPI } from "../../../../../fieldFailureReports/services/apiCalls";
var handleAttachmentDownload = function (value) { return __awaiter(void 0, void 0, void 0, function () {
    var request, res, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!value) return [3 /*break*/, 2];
                request = value;
                return [4 /*yield*/, downloadAttachmentFfrAPI({
                        request: request
                    })];
            case 1:
                res = _a.sent();
                url = URL.createObjectURL(res === null || res === void 0 ? void 0 : res.data);
                window.open(url, '_blank');
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
export var GeneralMobileViewAFR = [{
        type: FormItemTypes.Typography,
        name: "",
        fontSize: "md",
        fontWeight: "strong",
        children: "",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Supplier',
                        filedName: 'supplier'
                    }, {
                        label: 'Plant',
                        filedName: 'PlantCode',
                        secondFieldName: 'PlantName',
                        divider: true
                    }, {
                        label: 'Group',
                        filedName: 'ProductGroupCode',
                        secondFieldName: 'ProductGroupName',
                        divider: true
                    }, {
                        label: 'Product',
                        filedName: 'ModelCode',
                        secondFieldName: 'ModelName',
                        divider: true
                    }, {
                        label: 'Vehicle Manufacturing Date',
                        filedName: 'vehicleManufacturingDate'
                    }].map(function (item) {
                    return item.divider ? {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        display: "flex",
                        justifyContent: "space-between",
                        columnSize: 12,
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                label: "".concat(item.label, " :"),
                                columnSize: 0,
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                }
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: true,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: item.filedName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }, {
                                        type: FormItemTypes.Divider,
                                        orientation: 'vertical',
                                        name: '',
                                        columnSize: 0,
                                        containerProps: {
                                            height: "100%"
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: item.secondFieldName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }]
                            }]
                    } : {
                        type: FormItemTypes.Typography,
                        name: item.filedName,
                        label: item.label,
                        value: '-',
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        columnSize: 12,
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        containerProps: {
                            display: 'flex',
                            direction: 'row',
                            justifyContent: 'space-between'
                        },
                        valueGetter: function (formValues) { return (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-'; }
                    };
                }), true)
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "",
        fontSize: "md",
        fontWeight: "strong",
        children: "Repair Details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Branch',
                        filedName: 'BranchName'
                    }, {
                        label: 'Job Card Number',
                        filedName: 'JobCardNumber'
                    }, {
                        label: 'Part',
                        filedName: 'PartCode',
                        secondFieldName: 'PartName',
                        divider: true
                    }, {
                        label: 'KM Reading',
                        filedName: 'KMReading'
                    }, {
                        label: 'Repair Type',
                        filedName: 'RepairType'
                    }, {
                        label: 'Date Of Failure',
                        filedName: 'DateOfFailure',
                        date: true
                    }, {
                        label: 'Repair Date',
                        filedName: 'RepairDate',
                        date: true
                    }, {
                        label: 'Vendor Name',
                        filedName: 'VendorName'
                    }, {
                        label: 'Report Date',
                        filedName: 'ReportDate',
                        date: true
                    }, {
                        label: 'Reported By',
                        filedName: 'Reporter'
                    }, {
                        label: 'Reporter Mobile Number',
                        filedName: 'ReporterContact'
                    }, {
                        label: 'Parts Replaced',
                        filedName: 'PartsReplaced'
                    }, {
                        label: 'Vehicle Status After Repair',
                        filedName: 'VehicleStatusAfterRepair'
                    }].map(function (item) {
                    return item.divider ? {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        display: "flex",
                        justifyContent: "space-between",
                        columnSize: 12,
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                label: "".concat(item.label, " :"),
                                columnSize: 0,
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                }
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: true,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: item.filedName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }, {
                                        type: FormItemTypes.Divider,
                                        orientation: 'vertical',
                                        name: '',
                                        columnSize: 0,
                                        containerProps: {
                                            height: "100%"
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: item.secondFieldName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }]
                            }]
                    } : {
                        type: FormItemTypes.Typography,
                        name: item.filedName,
                        label: item.label,
                        value: '-',
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        columnSize: 12,
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        containerProps: {
                            display: 'flex',
                            direction: 'row',
                            justifyContent: 'space-between'
                        },
                        valueGetter: function (formValues, field) {
                            var _field$name, _field$name2;
                            return item !== null && item !== void 0 && item.date ? formValues !== null && formValues !== void 0 && formValues[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : '']).format('DD MMM, YYYY') : '-' : (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-';
                        }
                    };
                }), true)
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "",
        fontSize: "md",
        fontWeight: "strong",
        children: "Customer Complaint",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Performance',
                        filedName: 'PerformanceCode',
                        secondFieldName: 'PerformanceName',
                        divider: true
                    }, {
                        label: 'Defect',
                        filedName: 'DefectCode',
                        secondFieldName: 'DefectName',
                        divider: true
                    }, {
                        label: 'Problem Description',
                        filedName: 'ProblemDescription'
                    }, {
                        label: 'Temperature Condition',
                        filedName: 'TemperatureConditionName'
                    }, {
                        label: 'Vehicale Speed',
                        filedName: 'VehicleSpeed'
                    }, {
                        label: 'Road Condition',
                        filedName: 'RoadCondition'
                    }].map(function (item) {
                    return item.divider ? {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        display: "flex",
                        justifyContent: "space-between",
                        columnSize: 12,
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                label: "".concat(item.label, " :"),
                                columnSize: 0,
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                }
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: true,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: item.filedName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }, {
                                        type: FormItemTypes.Divider,
                                        orientation: 'vertical',
                                        name: '',
                                        columnSize: 0,
                                        containerProps: {
                                            height: "100%"
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: item.secondFieldName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }]
                            }]
                    } : {
                        type: FormItemTypes.Typography,
                        name: item.filedName,
                        label: item.label,
                        value: '-',
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        columnSize: 12,
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        containerProps: {
                            display: 'flex',
                            direction: 'row',
                            justifyContent: 'space-between'
                        },
                        valueGetter: function (formValues) { return (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-'; }
                    };
                }), true)
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "",
        fontSize: "md",
        fontWeight: "strong",
        children: "Customer Details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Customer Name',
                        filedName: 'CustomerName'
                    }, {
                        label: 'Customer Email',
                        filedName: 'CustomerEmail'
                    }, {
                        label: 'Mobile Number',
                        filedName: 'mobileNumber'
                    }].map(function (item) { return ({
                    type: FormItemTypes.Typography,
                    name: item.filedName,
                    label: item.label,
                    value: '-',
                    fontSize: 'sm',
                    fontWeight: 'medium',
                    columnSize: 12,
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    containerProps: {
                        display: 'flex',
                        direction: 'row',
                        justifyContent: 'space-between'
                    },
                    valueGetter: function (formValues) { return (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-'; }
                }); }), true)
            }]
    }];
export var ProductRepairAndCustomerDetails = [{
        type: FormItemTypes.Typography,
        name: "",
        fontSize: "md",
        fontWeight: "strong",
        children: "Product Details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "Product details",
                                label: "JC invoice return details",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "supplier",
                                        label: "Supplier :",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "plantCode",
                                        label: "Plant :",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: '',
                                                label: 'Group :',
                                                columnSize: 0,
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                }
                                            }, {
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                columnSize: true,
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                spacing: 1,
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: 'ProductGroupCode',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }, {
                                                        type: FormItemTypes.Divider,
                                                        orientation: 'vertical',
                                                        name: '',
                                                        columnSize: 0,
                                                        containerProps: {
                                                            height: "100%"
                                                        }
                                                    }, {
                                                        type: FormItemTypes.Typography,
                                                        name: 'ProductGroupName',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }]
                                            }]
                                    }]
                            }]
                    }, {
                        type: FormItemTypes.Divider,
                        name: "Divider",
                        orientation: "vertical",
                        columnSize: 0,
                        containerProps: {
                            height: "100%"
                        }
                    }, {
                        type: FormItemTypes.Box,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "productCodede",
                                label: "Return invoice summary",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: '',
                                                label: 'Product :',
                                                columnSize: 0,
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                }
                                            }, {
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                columnSize: true,
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                spacing: 1,
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: 'ModelCode',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }, {
                                                        type: FormItemTypes.Divider,
                                                        orientation: 'vertical',
                                                        name: '',
                                                        columnSize: 0,
                                                        containerProps: {
                                                            height: "100%"
                                                        }
                                                    }, {
                                                        type: FormItemTypes.Typography,
                                                        name: 'ModelName',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }]
                                            }]
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "vehicleManufacturingDate:",
                                        label: "Vehicle Manufacturing Date:",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "",
        fontSize: "md",
        fontWeight: "strong",
        children: "Repair Details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.Box,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "Repair details",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "BranchName",
                                        label: "Branch :",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "JobCardNumber",
                                        label: "Job Card Number:",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: '',
                                                label: 'Part :',
                                                columnSize: 0,
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                }
                                            }, {
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                columnSize: true,
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                spacing: 1,
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: 'PartCode',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }, {
                                                        type: FormItemTypes.Divider,
                                                        orientation: 'vertical',
                                                        name: '',
                                                        columnSize: 0,
                                                        containerProps: {
                                                            height: "100%"
                                                        }
                                                    }, {
                                                        type: FormItemTypes.Typography,
                                                        name: 'PartName',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }]
                                            }]
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "KMReading",
                                        label: "KM Reading:",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "RepairType",
                                        label: "Repair Type:",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        datatype: "date",
                                        type: FormItemTypes.Typography,
                                        name: "DateOfFailure",
                                        label: "Date Of Failure:",
                                        valueGetter: function (formValues, field) {
                                            var _field$name3, _field$name4;
                                            return formValues !== null && formValues !== void 0 && formValues[(_field$name3 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name3 !== void 0 ? _field$name3 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name4 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name4 !== void 0 ? _field$name4 : '']).format('DD MMM, YYYY') : '-';
                                        },
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "RepairDate",
                                        label: "RepairDate",
                                        valueGetter: function (formValues, field) {
                                            var _field$name5, _field$name6;
                                            return formValues !== null && formValues !== void 0 && formValues[(_field$name5 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name5 !== void 0 ? _field$name5 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name6 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name6 !== void 0 ? _field$name6 : '']).format('DD MMM, YYYY') : '-';
                                        },
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }, {
                        type: FormItemTypes.Divider,
                        name: "Divider",
                        orientation: "vertical",
                        columnSize: 0,
                        containerProps: {
                            height: "100%"
                        }
                    }, {
                        type: FormItemTypes.Box,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "repairDetails",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "VendorName",
                                        label: "Vendor Name:",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "ReportDate",
                                        label: "Report Date:",
                                        valueGetter: function (formValues, field) {
                                            var _field$name7, _field$name8;
                                            return formValues !== null && formValues !== void 0 && formValues[(_field$name7 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name7 !== void 0 ? _field$name7 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name8 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name8 !== void 0 ? _field$name8 : '']).format('DD MMM, YYYY') : '-';
                                        },
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "Reporter",
                                        label: "Reported By:",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "ReporterContact",
                                        label: "Reporter Mobile Number:",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "PartsReplaced",
                                        label: "Parts Replaced:",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "VehicleStatusAfterRepair",
                                        label: "Vehicle Status After Repair:",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "",
        fontSize: "md",
        fontWeight: "strong",
        children: "Customer Complaint",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.Box,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: '',
                                                children: 'Performance:',
                                                columnSize: 0,
                                                noWrap: true,
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                color: 'text.tertiary'
                                            }, {
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                columnSize: true,
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                spacing: 1,
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: 'PerformanceName',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }, {
                                                        type: FormItemTypes.Divider,
                                                        orientation: 'vertical',
                                                        name: '',
                                                        columnSize: 0,
                                                        containerProps: {
                                                            height: "100%"
                                                        }
                                                    }, {
                                                        type: FormItemTypes.Typography,
                                                        name: 'PerformanceCode',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }]
                                            }]
                                    }, {
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        alignItems: 'center',
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: '',
                                                children: 'Defect:',
                                                columnSize: 0,
                                                noWrap: true,
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                color: 'text.tertiary'
                                            }, {
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                columnSize: true,
                                                justifyContent: 'flex-end',
                                                spacing: 0,
                                                columnGap: 1,
                                                alignSelf: 'stretch',
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: 'DefectName',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }, {
                                                        type: FormItemTypes.Divider,
                                                        orientation: 'vertical',
                                                        name: '',
                                                        columnSize: 0,
                                                        containerProps: {
                                                            alignSelf: 'stretch'
                                                        }
                                                    }, {
                                                        type: FormItemTypes.Typography,
                                                        name: 'DefectCode',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }]
                                            }]
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "ProblemDescription",
                                        label: "Problem Description:",
                                        value: "Demo",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }, {
                        type: FormItemTypes.Divider,
                        name: "Divider",
                        orientation: "vertical",
                        columnSize: 0,
                        containerProps: {
                            height: "100%"
                        }
                    }, {
                        type: FormItemTypes.Box,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "TemperatureConditionName",
                                        label: "Temperature Condition:",
                                        value: "Dmeo",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "VehicleSpeed",
                                        label: "Vehicale Speed:",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "RoadCondition",
                                        label: "Road Condition:",
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    }];
export var ProductRepairAndCustomerDetailsMobileView = [{
        type: FormItemTypes.Typography,
        name: "ProductDetails",
        fontSize: "md",
        fontWeight: "strong",
        children: "Products Details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Supplier',
                        filedName: 'supplier'
                    }, {
                        label: 'Plant',
                        filedName: 'PlantCode',
                        secondFieldName: 'PlantName',
                        divider: true
                    }, {
                        label: 'Group',
                        filedName: 'ProductGroupCode',
                        secondFieldName: 'ProductGroupName',
                        divider: true
                    }, {
                        label: 'Product',
                        filedName: 'ModelCode',
                        secondFieldName: 'ModelName',
                        divider: true
                    }, {
                        label: 'Vehicle Manufacturing Date',
                        filedName: 'vehicleManufacturingDate'
                    }].map(function (item) {
                    return item.divider ? {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        display: "flex",
                        justifyContent: "space-between",
                        columnSize: 12,
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                label: "".concat(item.label, " :"),
                                columnSize: 0,
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                }
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: true,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: item.filedName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }, {
                                        type: FormItemTypes.Divider,
                                        orientation: 'vertical',
                                        name: '',
                                        columnSize: 0,
                                        containerProps: {
                                            height: "100%"
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: item.secondFieldName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }]
                            }]
                    } : {
                        type: FormItemTypes.Typography,
                        name: item.filedName,
                        label: item.label,
                        value: '-',
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        columnSize: 12,
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        containerProps: {
                            display: 'flex',
                            direction: 'row',
                            justifyContent: 'space-between'
                        },
                        valueGetter: function (formValues) { return (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-'; }
                    };
                }), true)
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "ProductDetails",
        fontSize: "md",
        fontWeight: "strong",
        children: "Repair Details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Branch',
                        filedName: 'BranchName'
                    }, {
                        label: 'Job Card Number',
                        filedName: 'JobCardNumber'
                    }, {
                        label: 'Part',
                        filedName: 'PartCode',
                        secondFieldName: 'PartName',
                        divider: true
                    }, {
                        label: 'KM Reading',
                        filedName: 'KMReading'
                    }, {
                        label: 'Repair Type',
                        filedName: 'RepairType'
                    }, {
                        label: 'Date Of Failure',
                        filedName: 'DateOfFailure',
                        date: true
                    }, {
                        label: 'Repair Date',
                        filedName: 'RepairDate',
                        date: true
                    }, {
                        label: 'Vendor Name',
                        filedName: 'VendorName'
                    }, {
                        label: 'Report Date',
                        filedName: 'ReportDate',
                        date: true
                    }, {
                        label: 'Reported By',
                        filedName: 'Reporter'
                    }, {
                        label: 'Reporter Mobile Number',
                        filedName: 'ReporterContact'
                    }, {
                        label: 'Parts Replaced',
                        filedName: 'PartsReplaced'
                    }, {
                        label: 'Vehicle Status After Repair',
                        filedName: 'VehicleStatusAfterRepair'
                    }].map(function (item) {
                    return item.divider ? {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        display: "flex",
                        justifyContent: "space-between",
                        columnSize: 12,
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                label: "".concat(item.label, " :"),
                                columnSize: 0,
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                }
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: true,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: item.filedName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }, {
                                        type: FormItemTypes.Divider,
                                        orientation: 'vertical',
                                        name: '',
                                        columnSize: 0,
                                        containerProps: {
                                            height: "100%"
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: item.secondFieldName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }]
                            }]
                    } : {
                        type: FormItemTypes.Typography,
                        name: item.filedName,
                        label: item.label,
                        value: '-',
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        columnSize: 12,
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        containerProps: {
                            display: 'flex',
                            direction: 'row',
                            justifyContent: 'space-between'
                        },
                        valueGetter: function (formValues, field) {
                            var _field$name9, _field$name10;
                            return item !== null && item !== void 0 && item.date ? formValues !== null && formValues !== void 0 && formValues[(_field$name9 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name9 !== void 0 ? _field$name9 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name10 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name10 !== void 0 ? _field$name10 : '']).format('DD MMM, YYYY') : '-' : (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-';
                        }
                    };
                }), true)
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "title",
        fontSize: "md",
        fontWeight: "strong",
        children: "Customer Complaint",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Performance',
                        filedName: 'PerformanceCode',
                        secondFieldName: 'PerformanceName',
                        divider: true
                    }, {
                        label: 'Defect',
                        filedName: 'DefectCode',
                        secondFieldName: 'DefectName',
                        divider: true
                    }, {
                        label: 'Problem Description',
                        filedName: 'ProblemDescription'
                    }, {
                        label: 'Temperature Condition',
                        filedName: 'TemperatureConditionName'
                    }, {
                        label: 'Vehicale Speed',
                        filedName: 'VehicleSpeed'
                    }, {
                        label: 'Road Condition',
                        filedName: 'RoadCondition'
                    }].map(function (item) {
                    return item.divider ? {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        display: "flex",
                        justifyContent: "space-between",
                        columnSize: 12,
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                label: "".concat(item.label, " :"),
                                columnSize: 0,
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                }
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: true,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: item.filedName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }, {
                                        type: FormItemTypes.Divider,
                                        orientation: 'vertical',
                                        name: '',
                                        columnSize: 0,
                                        containerProps: {
                                            height: "100%"
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: item.secondFieldName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }]
                            }]
                    } : {
                        type: FormItemTypes.Typography,
                        name: item.filedName,
                        label: item.label,
                        value: '-',
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        columnSize: 12,
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        containerProps: {
                            display: 'flex',
                            direction: 'row',
                            justifyContent: 'space-between'
                        },
                        valueGetter: function (formValues) { return (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-'; }
                    };
                }), true)
            }]
    }];
export var vehicleDefectivePartDetails = [{
        type: FormItemTypes.Typography,
        name: "",
        fontSize: "md",
        fontWeight: "strong",
        children: "Courier attachment",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.ContainerItem,
        name: '',
        columnSize: 12,
        pt: 2,
        elements: [{
                type: FormItemTypes.List,
                columnSize: 12,
                name: 'CourierAttachment',
                disableCheckboxSelection: true,
                value: null,
                columns: [{
                        field: 'ContentType',
                        maxWidth: 50,
                        renderCell: function (_ref) {
                            var row = _ref.row;
                            return renderIcon(row === null || row === void 0 ? void 0 : row.FileName);
                        }
                    }, {
                        field: "FileName",
                        flex: 1,
                        align: "left",
                        renderCell: function (_ref2) {
                            var value = _ref2.value, row = _ref2.row;
                            return /*#__PURE__*/ React.createElement(Box, {
                                sx: {
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.5
                                }
                            }, /*#__PURE__*/ React.createElement(Link, {
                                underline: "hover",
                                variant: "button",
                                color: "text.primary",
                                onClick: function () { return handleAttachmentDownload(row); }
                            }, value), /*#__PURE__*/ React.createElement(Typography, {
                                variant: "h6",
                                color: "text.secondary"
                            }, "Remarks:"));
                        }
                    }, {
                        field: "Size",
                        width: 465,
                        align: "left",
                        renderCell: function (_ref3) {
                            var value = _ref3.value, row = _ref3.row;
                            return /*#__PURE__*/ React.createElement(Box, {
                                sx: {
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.5
                                }
                            }, /*#__PURE__*/ React.createElement(Typography, {
                                variant: "h6",
                                sx: {
                                    alignSelf: "flex-end"
                                },
                                color: "text.secondary"
                            }, "".concat(Math.round(value / 1000), " KB")), /*#__PURE__*/ React.createElement(Typography, {
                                variant: "h6",
                                color: "text",
                                sx: {
                                    fontSize: "12px"
                                }
                            }, row === null || row === void 0 ? void 0 : row.Remark));
                        }
                    }]
            }]
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "courierdetails",
                                label: "JC invoice return details",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "previoussubmittedsample",
                                        label: "Previously submitted samples:",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "Courierdetails",
                                label: "JC invoice return details",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "remark",
                                        label: "ASM remarks",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    },
    // ------------------------
    {
        type: FormItemTypes.Typography,
        name: "Vehicledetails",
        fontSize: "md",
        fontWeight: "strong",
        children: "Vehicle details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: '',
                                                label: 'Group code & name:',
                                                columnSize: 0,
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                }
                                            }, {
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                columnSize: true,
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                spacing: 1,
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: 'ProductGroupCode',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }, {
                                                        type: FormItemTypes.Divider,
                                                        orientation: 'vertical',
                                                        name: '',
                                                        columnSize: 0,
                                                        containerProps: {
                                                            height: "100%"
                                                        }
                                                    }, {
                                                        type: FormItemTypes.Typography,
                                                        name: 'ProductGroupName',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }]
                                            }]
                                    }, {
                                        datatype: "date",
                                        type: FormItemTypes.Typography,
                                        name: "FFRReportDate",
                                        label: "First field report date",
                                        valueGetter: function (formValues, field) {
                                            var _field$name11, _field$name12;
                                            return formValues !== null && formValues !== void 0 && formValues[(_field$name11 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name11 !== void 0 ? _field$name11 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name12 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name12 !== void 0 ? _field$name12 : '']).format('DD MMM, YYYY') : '-';
                                        },
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "CustomerVoice",
                                        label: "Customer voice :",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }, {
                        type: FormItemTypes.Divider,
                        name: "Divider",
                        orientation: "vertical",
                        columnSize: 0,
                        containerProps: {
                            height: "100%"
                        }
                    }, {
                        type: FormItemTypes.Box,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "productCodede",
                                label: "Return invoice summary",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "DefectPhenomenon",
                                        label: "Defect phenomenon:",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "RootCause",
                                        label: "Root Cause:",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "ProductDetails",
        fontSize: "md",
        fontWeight: "strong",
        children: "Defective part details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: '',
                                                label: 'Main defective part:',
                                                columnSize: 0,
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                }
                                            }, {
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                columnSize: true,
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                spacing: 1,
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: 'DefectCode',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }, {
                                                        type: FormItemTypes.Divider,
                                                        orientation: 'vertical',
                                                        name: '',
                                                        columnSize: 0,
                                                        containerProps: {
                                                            height: "100%"
                                                        }
                                                    }, {
                                                        type: FormItemTypes.Typography,
                                                        name: 'DefectName',
                                                        fontWeight: "medium",
                                                        columnSize: 0,
                                                        fontSize: "sm"
                                                    }]
                                            }]
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "PriorityName",
                                        label: "Priority",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }, {
                        type: FormItemTypes.Divider,
                        name: "Divider",
                        orientation: "vertical",
                        columnSize: 0,
                        containerProps: {
                            height: "100%"
                        }
                    }, {
                        type: FormItemTypes.Box,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "CategoryName",
                                        label: "Category",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    }];
export var vehicleDefectivePartDetailsMobileView = [{
        type: FormItemTypes.Typography,
        name: "",
        fontSize: "md",
        fontWeight: "strong",
        children: "Courier attachment",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.ContainerItem,
        name: '',
        columnSize: 12,
        pt: 2,
        elements: [{
                type: FormItemTypes.List,
                columnSize: 12,
                name: 'CourierAttachment',
                disableCheckboxSelection: true,
                value: null,
                columns: [{
                        field: 'ContentType',
                        maxWidth: 50,
                        renderCell: function (_ref4) {
                            var row = _ref4.row;
                            return renderIcon(row === null || row === void 0 ? void 0 : row.FileName);
                        }
                    }, {
                        field: "FileName",
                        flex: 1,
                        align: "left",
                        renderCell: function (_ref5) {
                            var value = _ref5.value, row = _ref5.row;
                            return /*#__PURE__*/ React.createElement(Box, {
                                sx: {
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.5
                                }
                            }, /*#__PURE__*/ React.createElement(Link, {
                                underline: "hover",
                                variant: "button",
                                color: "text.primary",
                                onClick: function () { return handleAttachmentDownload(row); }
                            }, value), /*#__PURE__*/ React.createElement(Typography, {
                                variant: "h6",
                                color: "text.secondary"
                            }, "Remarks:"));
                        }
                    }, {
                        field: "Size",
                        width: 465,
                        align: "left",
                        renderCell: function (_ref6) {
                            var value = _ref6.value, row = _ref6.row;
                            return /*#__PURE__*/ React.createElement(Box, {
                                sx: {
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.5
                                }
                            }, /*#__PURE__*/ React.createElement(Typography, {
                                variant: "h6",
                                sx: {
                                    alignSelf: "flex-end"
                                },
                                color: "text.secondary"
                            }, "".concat(Math.round(value / 1000), " KB")), /*#__PURE__*/ React.createElement(Typography, {
                                variant: "h6",
                                color: "text",
                                sx: {
                                    fontSize: "12px"
                                }
                            }, row === null || row === void 0 ? void 0 : row.Remark));
                        }
                    }]
            }]
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "courierdetails",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "PreviouslySubmittedSample",
                                        label: "Previously submitted samples:",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "Courierdetails",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: "remark",
                                        label: "ASM remarks",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    },
    // ------------------------
    {
        type: FormItemTypes.Typography,
        name: "Vehicledetails",
        fontSize: "md",
        fontWeight: "strong",
        children: "Vehicle details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: "ProductGroupCode",
                                                label: "Group code :",
                                                value: '-',
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "ProductGroupName",
                                                label: "Group Name :",
                                                value: '-',
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }]
                                    }, {
                                        datatype: "date",
                                        type: FormItemTypes.Typography,
                                        name: "FFRReportDate",
                                        label: "First field report date",
                                        valueGetter: function (formValues, field) {
                                            var _field$name13, _field$name14;
                                            return formValues !== null && formValues !== void 0 && formValues[(_field$name13 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name13 !== void 0 ? _field$name13 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name14 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name14 !== void 0 ? _field$name14 : '']).format('DD MMM, YYYY') : '-';
                                        },
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "CustomerVoice",
                                        label: "Customer voice :",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "DefectPhenomenon",
                                        label: "Defect phenomenon:",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "RootCause",
                                        label: "Root Cause:",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "",
        fontSize: "md",
        fontWeight: "strong",
        children: "Defective part details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: "",
                columnSize: 12,
                sx: {
                    pt: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "header",
                        columnSize: true,
                        sx: {
                            border: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "",
                                label: "",
                                display: "flex",
                                justifyContent: "space-between",
                                columnSize: 12,
                                spacing: 0,
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: "DefectCode",
                                                label: "Main defective part code:",
                                                value: '-',
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "DefectName",
                                                label: "Main defective part Name:",
                                                value: '-',
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }]
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "PriorityName",
                                        label: "Priority",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: "CategoryName",
                                        label: "Category",
                                        value: '-',
                                        containerProps: {
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            gap: 1
                                        },
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: "medium",
                                            fontSize: "sm"
                                        },
                                        fontWeight: "medium",
                                        fontSize: "sm",
                                        columnSize: 12
                                    }]
                            }]
                    }]
            }]
    }];
